
import React, { Component } from 'react';
import AddButton from '../addButton';


// Time slots used across the app
const TIMESLOTS = [
    { label: '9:30 AM', key: 'avail930', hhmm: '09:30' },
    { label: '10:30 AM', key: 'avail1030', hhmm: '10:30' },
    { label: '11:30 AM', key: 'avail1130', hhmm: '11:30' },
    { label: '12:30 PM', key: 'avail1230', hhmm: '12:30' },
    { label: '1:30 PM', key: 'avail130', hhmm: '13:30' },
];

class Calendar extends Component {
    _bulkTimer = null;
    constructor(props) {
        super(props);
        // Determine initial module and type before first render (kept to mirror your Dynamic structure)
        let initialView = 'Calendar';
        let initialSortBy = '';
        let initialType = 'custom';

        for (const mod in (props.data || {})) {
            if (props.data[mod] && props.data[mod].hasOwnProperty('schema')) {
                initialView = mod;
                initialSortBy = props.data[mod].sortBy;
                const dd = props.data[mod].settings && Array.isArray(props.data[mod].settings.dropdowns)
                    ? props.data[mod].settings.dropdowns
                    : null;
                if (dd && dd.length > 0) {
                    initialType = dd[0]; // use first item in dropdowns
                }
                break;
            }
        }

        const defaultBoroughs = (props.boroughs && Array.isArray(props.boroughs) && props.boroughs.length > 0)
            ? props.boroughs
            : ['Manhattan', 'Brooklyn', 'Queens', 'Bronx', 'Staten Island'];
        const initialBorough = props.defaultBorough && defaultBoroughs.includes(props.defaultBorough)
            ? props.defaultBorough
            : defaultBoroughs[0];

        this.state = {
            active: true,               // show the page (mirror)
            view: initialView,          // unused for now but kept for parity
            sortBy: initialSortBy,      // unused for now but kept for parity
            sortOrder: 1,               // unused for now but kept for parity
            type: initialType,          // unused for now but kept for parity
            boroughs: defaultBoroughs,
            borough: initialBorough,

            // Calendar-specific
            currentMonth: this.atLocalMidnight(props.defaultMonth ? new Date(props.defaultMonth) : new Date()),
            // Borough-aware data map: { [borough]: { 'YYYY-MM-DD': { ...fields } } }
            dataByBorough: (() => {
                // Prefer a borough-scoped initial payload, else seed only the initial borough with any legacy initialData.
                if (props.initialDataByBorough && typeof props.initialDataByBorough === 'object') {
                    return { ...props.initialDataByBorough };
                }
                const seed = { ...(props.initialData || {}) };
                return { [initialBorough]: seed };
            })(),
            editing: null,              // Date object when editing, else null
            draft: { avail930: 0, issued930: 0, avail1030: 0, issued1030: 0, avail1130: 0, issued1130: 0, avail1230: 0, issued1230: 0, avail130: 0, issued130: 0 },
            loading: false,
            error: '',
            // Bulk month add UI
            bulkAddOpen: false,
            bulkMonth: (() => {
                const d = new Date();
                const y = d.getFullYear();
                const m = (d.getMonth() + 1).toString().padStart(2, '0');
                return `${y}-${m}`; // YYYY-MM for <input type="month">
            })(),
            bulkByBorough: (() => {
                const out = {};
                const list = (props.boroughs && Array.isArray(props.boroughs) && props.boroughs.length > 0)
                    ? props.boroughs
                    : ['Manhattan', 'Brooklyn', 'Queens', 'Bronx', 'Staten Island'];
                list.forEach(b => {
                    out[b] = { avail930: 0, avail1030: 0, avail1130: 0, avail1230: 0, avail130: 0 };
                });
                return out;
            })(),
            bulkSaving: false,
        };
    }

    /* ---------------- Utilities kept as class fields for “everything in the class” ---------------- */
    pad2 = (n) => (n < 10 ? `0${n}` : `${n}`);
    ymd = (d) => `${d.getFullYear()}-${this.pad2(d.getMonth() + 1)}-${this.pad2(d.getDate())}`;
    atLocalMidnight = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
    addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
    startOfMonth = (d) => this.atLocalMidnight(new Date(d.getFullYear(), d.getMonth(), 1));
    endOfMonth = (d) => this.atLocalMidnight(new Date(d.getFullYear(), d.getMonth() + 1, 0));
    getMonthLabel = (d) => d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    truncate = (s, n) => (!s ? '' : (s.length > n ? s.slice(0, n - 1) + '…' : s));

    toInt = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
    };

    getTotals = (entry) => {
        if (!entry) return { totalAvailable: 0, totalIssued: 0 };
        const a = (k) => this.toInt(entry[k]);
        const totalAvailable =
            a('avail930') + a('avail1030') + a('avail1130') + a('avail1230') + a('avail130');
        const totalIssued =
            a('issued930') + a('issued1030') + a('issued1130') + a('issued1230') + a('issued130');
        return { totalAvailable, totalIssued };
    };

    ensureBoroughKey = (b) => {
        if (!this.state.dataByBorough[b]) {
            this.setState((prev) => ({
                dataByBorough: { ...prev.dataByBorough, [b]: {} }
            }));
        }
    };

    getCurrentDataMap = () => {
        const map = this.state.dataByBorough[this.state.borough];
        return map ? map : {};
    };

    fetchMonthData = () => {
        const y = this.state.currentMonth.getFullYear();
        const m = this.state.currentMonth.getMonth() + 1; // 1..12
        const payload = {
            route: 'getCalendarMonth',
            borough: this.state.borough,
            year: y,
            month: m,
        };
        if (this.props.ws && typeof this.props.ws.send === 'function') {
            try {
                this.props.ws.send(JSON.stringify(payload));
            } catch (e) { /* noop */ }
        }
        if (typeof this.props.onFetchMonth === 'function') {
            // optional callback hook if parent prefers HTTP instead of WS
            this.props.onFetchMonth({ borough: this.state.borough, year: y, month: m });
        }
    };

    /* ---------------- Lifecycle parity ---------------- */
    componentDidMount() {
        if (this.props.ws && typeof this.props.ws.addEventListener === 'function') {
            this._calendarMsgHandler = (event) => {
                try {
                    const msg = JSON.parse(event.data);
                    if (msg && msg.route === 'calendarMonthData' && msg.data) {
                        const { borough, byDate } = msg.data;
                        this.setState((prev) => ({
                            dataByBorough: { ...prev.dataByBorough, [borough]: byDate }
                        }));
                    }
                    // When backend confirms bulk month save, stop loading and refresh month data (do not reinsert)
                    if (
                        (msg && (msg.route === 'calendarMonthSaved' || msg.route === 'saveCalendarMonthOK' || msg.route === 'calendarMonthOK')) ||
                        (msg && msg.route === 'saveCalendarMonth' && (msg.status === 'OK' || msg.ok === true || msg.message === 'OK')) ||
                        (msg && (msg.type === 'ok' || msg.type === 'OK'))
                    ) {
                        if (this._bulkTimer) { clearTimeout(this._bulkTimer); this._bulkTimer = null; }
                        this.setState({ bulkSaving: false, bulkAddOpen: false }, () => {
                            this.fetchMonthData();
                        });
                        return;
                    }

                    // Defensive: if fresh data for the current borough arrives while bulkSaving, stop the loader
                    if (this.state.bulkSaving && msg && msg.route === 'calendarMonthData' && msg.data && msg.data.borough === this.state.borough) {
                        if (this._bulkTimer) { clearTimeout(this._bulkTimer); this._bulkTimer = null; }
                        this.setState({ bulkSaving: false, bulkAddOpen: false });
                    }
                } catch (e) { /* ignore non-JSON frames */ }
            };
            this.props.ws.addEventListener('message', this._calendarMsgHandler);
        }
        this.fetchMonthData();
    }
    componentWillReceiveProps(nextProps) {
        // keep in sync if parent hands new initial data
        if (nextProps.initialDataByBorough && nextProps.initialDataByBorough !== this.props.initialDataByBorough) {
            this.setState({ dataByBorough: { ...nextProps.initialDataByBorough } });
        } else if (nextProps.initialData && nextProps.initialData !== this.props.initialData) {
            // Legacy shape: apply to current borough only
            this.setState((prev) => ({
                dataByBorough: { ...prev.dataByBorough, [prev.borough]: { ...nextProps.initialData } }
            }));
        }
    }
    componentWillUnmount() {
        if (this.props.ws && this._calendarMsgHandler && typeof this.props.ws.removeEventListener === 'function') {
            this.props.ws.removeEventListener('message', this._calendarMsgHandler);
        }
        if (this._bulkTimer) { clearTimeout(this._bulkTimer); this._bulkTimer = null; }
    }

    /* ---------------- Actions (mirroring edit/confirm/cancel/delete) ---------------- */
    edit = (dateObj) => (e) => {
        const key = this.ymd(dateObj);
        const existing = this.getCurrentDataMap()[key] || {};
        this.setState({
            editing: this.atLocalMidnight(dateObj),
            draft: {
                avail930: this.toInt(existing.avail930 || 0),
                issued930: this.toInt(existing.issued930 || 0),
                avail1030: this.toInt(existing.avail1030 || 0),
                issued1030: this.toInt(existing.issued1030 || 0),
                avail1130: this.toInt(existing.avail1130 || 0),
                issued1130: this.toInt(existing.issued1130 || 0),
                avail1230: this.toInt(existing.avail1230 || 0),
                issued1230: this.toInt(existing.issued1230 || 0),
                avail130: this.toInt(existing.avail130 || 0),
                issued130: this.toInt(existing.issued130 || 0),
            },
            error: ''
        });
    }

    cancel = () => {
        this.setState({ editing: null, draft: { avail930: 0, issued930: 0, avail1030: 0, issued1030: 0, avail1130: 0, issued1130: 0, avail1230: 0, issued1230: 0, avail130: 0, issued130: 0 }, loading: false, error: '' });
    }

    confirm = () => {
        if (!this.state.editing) return;
        const key = this.ymd(this.state.editing);
        const trimmed = {
            avail930: this.toInt(this.state.draft.avail930),
            issued930: this.toInt(this.state.draft.issued930),
            avail1030: this.toInt(this.state.draft.avail1030),
            issued1030: this.toInt(this.state.draft.issued1030),
            avail1130: this.toInt(this.state.draft.avail1130),
            issued1130: this.toInt(this.state.draft.issued1130),
            avail1230: this.toInt(this.state.draft.avail1230),
            issued1230: this.toInt(this.state.draft.issued1230),
            avail130: this.toInt(this.state.draft.avail130),
            issued130: this.toInt(this.state.draft.issued130),
        };
        const isEmpty =
            trimmed.avail930 === 0 && trimmed.issued930 === 0 &&
            trimmed.avail1030 === 0 && trimmed.issued1030 === 0 &&
            trimmed.avail1130 === 0 && trimmed.issued1130 === 0 &&
            trimmed.avail1230 === 0 && trimmed.issued1230 === 0 &&
            trimmed.avail130 === 0 && trimmed.issued130 === 0;

        this.setState({ loading: true }, async () => {
            const currentBorough = this.state.borough;
            const currentMap = { ...this.getCurrentDataMap() };
            if (isEmpty) {
                delete currentMap[key];
            } else {
                currentMap[key] = trimmed;
            }
            const next = { ...this.state.dataByBorough, [currentBorough]: currentMap };

            // optional: notify parent or server
            try {
                if (this.props.onSave) {
                    await Promise.resolve(this.props.onSave(key, isEmpty ? null : trimmed));
                } else if (this.props.ws) {
                    this.props.ws.send(JSON.stringify({
                        route: 'saveCalendarDay',
                        borough: this.state.borough,
                        date: key,
                        ...trimmed
                    }));
                }
                this.setState({ dataByBorough: next, loading: false, editing: null, draft: { avail930: 0, issued930: 0, avail1030: 0, issued1030: 0, avail1130: 0, issued1130: 0, avail1230: 0, issued1230: 0, avail130: 0, issued130: 0 } });
                this.fetchMonthData();
            } catch (err) {
                this.setState({ loading: false, error: 'Failed to save. Try again.' });
            }
        });
    }

    delete = () => {
        if (!this.state.editing) return;
        const key = this.ymd(this.state.editing);

        this.setState({ loading: true }, async () => {
            const currentBorough = this.state.borough;
            const currentMap = { ...this.getCurrentDataMap() };
            delete currentMap[key];
            const next = { ...this.state.dataByBorough, [currentBorough]: currentMap };

            try {
                if (this.props.onSave) {
                    await Promise.resolve(this.props.onSave(key, null));
                } else if (this.props.ws) {
                    this.props.ws.send(JSON.stringify({
                        route: 'saveCalendarDay',
                        module: this.state.view,
                        item: { date: key, delete: true }
                    }));
                }
                this.setState({ dataByBorough: next, loading: false, editing: null, draft: { avail930: 0, issued930: 0, avail1030: 0, issued1030: 0, avail1130: 0, issued1130: 0, avail1230: 0, issued1230: 0, avail130: 0, issued130: 0 } });
            } catch (err) {
                this.setState({ loading: false, error: 'Failed to delete. Try again.' });
            }
        });
    }

    openBulkAdd = () => {
        // Initialize borough fields in case list changed
        const fresh = {};
        this.state.boroughs.forEach(b => {
            const prev = this.state.bulkByBorough[b] || {};
            fresh[b] = {
                avail930: this.toInt(prev.avail930 || 0),
                avail1030: this.toInt(prev.avail1030 || 0),
                avail1130: this.toInt(prev.avail1130 || 0),
                avail1230: this.toInt(prev.avail1230 || 0),
                avail130: this.toInt(prev.avail130 || 0),
            };
        });
        this.setState({ bulkAddOpen: true, bulkByBorough: fresh });
    };

    addDomain = () => {
        this.openBulkAdd();
    };

    cancelBulk = () => this.setState({ bulkAddOpen: false });

    confirmBulk = () => {
        if (this.state.bulkSaving) return; // prevent duplicate insert
        // We are not wiring backend here per your note; just stage the payload for next step
        const { bulkMonth, bulkByBorough } = this.state;
        const payload = { month: bulkMonth, byBorough: { ...bulkByBorough } };
        try {
            this.setState({ bulkSaving: true });
            if (this._bulkTimer) { clearTimeout(this._bulkTimer); }
            this._bulkTimer = setTimeout(() => {
                // Fallback stop if no explicit OK comes back
                this.setState({ bulkSaving: false });
            }, 20000);
            if (this.props.ws && typeof this.props.ws.send === 'function') {
                this.props.ws.send(JSON.stringify({ route: 'saveCalendarMonth', payload }));
            } else if (typeof this.props.onBulkPlan === 'function') {
                this.props.onBulkPlan(payload);
            }
        } catch (_) { /* no-op */ }
        this.setState({ bulkAddOpen: false });
    };
    changeBorough = (e) => {
        const b = e.target.value;
        this.setState({ borough: b }, () => { this.ensureBoroughKey(b); this.fetchMonthData(); });
    };

    checkEnter = (e) => {
        if (e.keyCode === 13) {
            this.confirm();
        }
    }

    /* ---------------- Month nav ---------------- */
    gotoPrevMonth = () => this.setState(({ currentMonth }) => ({
        currentMonth: new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1)
    }), this.fetchMonthData);
    gotoNextMonth = () => this.setState(({ currentMonth }) => ({
        currentMonth: new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1)
    }), this.fetchMonthData);
    gotoToday = () => this.setState({ currentMonth: this.atLocalMidnight(new Date()) }, this.fetchMonthData);

    /* ---------------- Render helpers ---------------- */
    buildGrid = () => {
        const start = this.startOfMonth(this.state.currentMonth);
        const firstDayIdx = start.getDay();
        const gridStart = this.addDays(start, -firstDayIdx);
        return Array.from({ length: 42 }, (_, i) => this.addDays(gridStart, i));
    }

    /* ---------------- Render ---------------- */
    render() {
        if (!this.state.active) return (<div width="100%"></div>);

        const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const days = this.buildGrid();
        const todayKey = this.ymd(this.atLocalMidnight(new Date()));

        /* Header + Controls (styled similar to your tables header area) */
        const header = (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', marginBottom: 12 }}>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <button style={styles.navBtn} onClick={this.gotoPrevMonth} aria-label="Previous month">‹</button>
                    <button style={styles.navBtn} onClick={this.gotoToday} aria-label="Go to today">Today</button>
                    <button style={styles.navBtn} onClick={this.gotoNextMonth} aria-label="Next month">›</button>
                </div>
                <div style={styles.monthLabel}>{this.getMonthLabel(this.state.currentMonth)}</div>
                <div style={{ justifySelf: 'end' }}>
                    <select
                        value={this.state.borough}
                        onChange={this.changeBorough}
                        style={{
                            border: '1px solid #ddd',
                            borderRadius: 8,
                            padding: '8px 10px',
                            fontWeight: 600,
                            color: '#134064',
                            cursor: 'pointer'
                        }}
                    >
                        {this.state.boroughs.map((b) => (
                            <option key={b} value={b}>{b}</option>
                        ))}
                    </select>
                </div>
            </div>
        );

        /* Weekday header row */
        const weekHeader = (
            <div style={styles.weekRow}>
                {WEEKDAYS.map((d) => (
                    <div key={d} style={styles.weekCell}>{d}</div>
                ))}
            </div>
        );

        /* Calendar grid */
        const grid = (
            <div style={styles.grid}>
                {days.map((dateObj) => {
                    const key = this.ymd(dateObj);
                    const inCurrentMonth = dateObj.getMonth() === this.state.currentMonth.getMonth();
                    const isToday = key === todayKey;
                    const entry = this.getCurrentDataMap()[key];
                    const hasData = !!entry;
                    const title = hasData ? (entry.title || '(No title)') : '';

                    return (
                        <button
                            key={key}
                            onClick={this.edit(dateObj)}
                            className="dataRow"
                            style={{
                                ...styles.cell,
                                opacity: inCurrentMonth ? 1 : 0.45,
                                border: isToday ? '2px solid #2A6AA9' : '1px solid #e5e7eb',
                                background: '#fff'
                            }}
                            title={
                                hasData
                                    ? (() => {
                                        const { totalAvailable, totalIssued } = this.getTotals(entry);
                                        return [
                                            `Totals — Avail: ${totalAvailable} • Issued: ${totalIssued}`,
                                            `9:30  A:${this.toInt(entry.avail930)} I:${this.toInt(entry.issued930)}`,
                                            `10:30 A:${this.toInt(entry.avail1030)} I:${this.toInt(entry.issued1030)}`,
                                            `11:30 A:${this.toInt(entry.avail1130)} I:${this.toInt(entry.issued1130)}`,
                                            `12:30 A:${this.toInt(entry.avail1230)} I:${this.toInt(entry.issued1230)}`,
                                            `1:30  A:${this.toInt(entry.avail130)} I:${this.toInt(entry.issued130)}`
                                        ].join('\n');
                                    })()
                                    : ''
                            }
                        >
                            <div style={styles.cellHeader}>
                                <div style={{ fontWeight: 700, color: '#137' }}>{dateObj.getDate()}</div>
                                {hasData && <span style={styles.dot} />}
                            </div>
                            {hasData && (() => {
                                const { totalAvailable, totalIssued } = this.getTotals(entry);
                                return (
                                    <div style={styles.cellBody}>
                                        <div style={styles.titleText}>Total Available: {totalAvailable}</div>
                                        <div style={styles.notesText}>Total Issued: {totalIssued}</div>
                                    </div>
                                );
                            })()}
                        </button>
                    );
                })}
            </div>
        );

        // Editor modal for 10 numeric fields
        let editing = null;
        if (this.state.editing) {
            editing = (
                <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter} onMouseDown={(e) => { if (e.target === e.currentTarget) this.cancel(); }}>
                    <div className="pop" onMouseDown={(e) => e.stopPropagation()}>
                        <div className="viewCloser" onClick={this.cancel}></div>

                        <div style={{ fontSize: 18, fontWeight: 700, color: '#134064', marginBottom: 10 }}>
                            {new Date(this.state.editing).toLocaleDateString('en-US', {
                                weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'
                            })}
                        </div>

                        {/* Time slot columns (horizontal) with Available input and non-editable Issued */}
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, minmax(0, 1fr))', gap: 14 }}>
                            {/* 9:30 */}
                            <div style={styles.slotBox}>
                                <div style={styles.slotHeader}>9:30 AM</div>
                                <div style={styles.numFieldCompact}>
                                    <label style={styles.numLabel}>Available</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={this.state.draft.avail930}
                                        onChange={(e) => this.setState({ draft: { ...this.state.draft, avail930: this.toInt(e.target.value) } })}
                                        style={styles.numInput}
                                    />
                                </div>
                                <div style={styles.numFieldCompact}>
                                    <label style={styles.numLabel}>Issued</label>
                                    <div style={styles.staticValue}>{this.state.draft.issued930}</div>
                                </div>
                            </div>

                            {/* 10:30 */}
                            <div style={styles.slotBox}>
                                <div style={styles.slotHeader}>10:30 AM</div>
                                <div style={styles.numFieldCompact}>
                                    <label style={styles.numLabel}>Available</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={this.state.draft.avail1030}
                                        onChange={(e) => this.setState({ draft: { ...this.state.draft, avail1030: this.toInt(e.target.value) } })}
                                        style={styles.numInput}
                                    />
                                </div>
                                <div style={styles.numFieldCompact}>
                                    <label style={styles.numLabel}>Issued</label>
                                    <div style={styles.staticValue}>{this.state.draft.issued1030}</div>
                                </div>
                            </div>

                            {/* 11:30 */}
                            <div style={styles.slotBox}>
                                <div style={styles.slotHeader}>11:30 AM</div>
                                <div style={styles.numFieldCompact}>
                                    <label style={styles.numLabel}>Available</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={this.state.draft.avail1130}
                                        onChange={(e) => this.setState({ draft: { ...this.state.draft, avail1130: this.toInt(e.target.value) } })}
                                        style={styles.numInput}
                                    />
                                </div>
                                <div style={styles.numFieldCompact}>
                                    <label style={styles.numLabel}>Issued</label>
                                    <div style={styles.staticValue}>{this.state.draft.issued1130}</div>
                                </div>
                            </div>

                            {/* 12:30 */}
                            <div style={styles.slotBox}>
                                <div style={styles.slotHeader}>12:30 PM</div>
                                <div style={styles.numFieldCompact}>
                                    <label style={styles.numLabel}>Available</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={this.state.draft.avail1230}
                                        onChange={(e) => this.setState({ draft: { ...this.state.draft, avail1230: this.toInt(e.target.value) } })}
                                        style={styles.numInput}
                                    />
                                </div>
                                <div style={styles.numFieldCompact}>
                                    <label style={styles.numLabel}>Issued</label>
                                    <div style={styles.staticValue}>{this.state.draft.issued1230}</div>
                                </div>
                            </div>

                            {/* 1:30 */}
                            <div style={styles.slotBox}>
                                <div style={styles.slotHeader}>1:30 PM</div>
                                <div style={styles.numFieldCompact}>
                                    <label style={styles.numLabel}>Available</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={this.state.draft.avail130}
                                        onChange={(e) => this.setState({ draft: { ...this.state.draft, avail130: this.toInt(e.target.value) } })}
                                        style={styles.numInput}
                                    />
                                </div>
                                <div style={styles.numFieldCompact}>
                                    <label style={styles.numLabel}>Issued</label>
                                    <div style={styles.staticValue}>{this.state.draft.issued130}</div>
                                </div>
                            </div>
                        </div>

                        <div className="error" style={{ padding: '10px', minHeight: 20 }}>{this.state.error}</div>

                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 10 }}>
                            {this.state.loading
                                ? <div className="loader"></div>
                                : <div className="button" onClick={this.confirm}>Save</div>}
                        </div>
                    </div>
                </div>
            );
        }

        const addButton = (
            <AddButton onClick={this.addDomain} />
        );

        // Global loading overlay while month updates are processing
        const bulkSavingOverlay = this.state.bulkSaving ? (
            <div className="blackout" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="pop" onMouseDown={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
                    <div className="loader"></div>
                    <div style={{ fontSize: 16, fontWeight: 600, color: '#134064' }}>Updating all calendar dates…</div>
                </div>
            </div>
        ) : null;

        return (
            <div width="100%">
                {header}
                {weekHeader}
                {grid}
                {editing}
                {addButton}
                {this.state.bulkAddOpen && (
                    <div className="blackout" tabIndex="1" autoFocus onMouseDown={(e) => { if (e.target === e.currentTarget) this.cancelBulk(); }}>
                        <div className="pop" onMouseDown={(e) => e.stopPropagation()} style={{ maxWidth: 720 }}>
                            <div className="viewCloser" onClick={this.cancelBulk}></div>
                            <div style={{ fontSize: 18, fontWeight: 700, color: '#134064', marginBottom: 12 }}>Add Month – All Boroughs</div>

                            <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                                <label style={{ fontSize: 14, color: '#6b7280', fontWeight: 600 }}>Month</label>
                                <input
                                    type="month"
                                    value={this.state.bulkMonth}
                                    onChange={(e) => this.setState({ bulkMonth: e.target.value })}
                                    style={styles.numInput}
                                />
                            </div>


                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 12, marginBottom: 16, justifyContent: 'center', marginLeft: 'auto', marginRight: 'auto' }}>
                                {this.state.boroughs.map((b) => (
                                    <div key={b} style={styles.slotBox}>
                                        <div style={{ ...styles.slotHeader, marginBottom: 6 }}>{b}</div>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8 }}>
                                            {TIMESLOTS.map((t) => (
                                                <div key={t.key} style={styles.numFieldCompact}>
                                                    <label style={styles.numLabel}>{t.label}</label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        step="1"
                                                        value={this.toInt((this.state.bulkByBorough[b] && this.state.bulkByBorough[b][t.key]) || 0)}
                                                        onChange={(e) => this.setState({ bulkByBorough: { ...this.state.bulkByBorough, [b]: { ...this.state.bulkByBorough[b], [t.key]: this.toInt(e.target.value) } } })}
                                                        style={styles.numInput}
                                                    />
                                                </div>
                                            ))}
                                            {/* All-times setter: appears next to 1:30 */}
                                            <div key="availAll" style={styles.allBox}>
                                                <label style={styles.numLabel}>All</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="1"
                                                    value={(() => {
                                                        const prev = (this.state.bulkByBorough[b] || {});
                                                        const vals = TIMESLOTS.map(t => this.toInt(prev[t.key] || 0));
                                                        return vals.length && vals.every(v => v === vals[0]) ? vals[0] : '';
                                                    })()}
                                                    onChange={(e) => {
                                                        const v = this.toInt(e.target.value);
                                                        this.setState(prev => {
                                                            const byB = { ...(prev.bulkByBorough[b] || {}) };
                                                            TIMESLOTS.forEach(t => { byB[t.key] = v; });
                                                            return { bulkByBorough: { ...prev.bulkByBorough, [b]: byB } };
                                                        });
                                                    }}
                                                    style={styles.numInput}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {/* Inline "All Boroughs" controller card */}
                                <div key="ALL_BOROUGHS" style={{ ...styles.slotBox, border: '2px solid #2A6AA9' }}>
                                    <div style={{ ...styles.slotHeader, marginBottom: 6 }}>All Boroughs</div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8 }}>
                                        {TIMESLOTS.map((t) => (
                                            <div key={`all-${t.key}`} style={styles.numFieldCompact}>
                                                <label style={styles.numLabel}>{t.label}</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="1"
                                                    value={(() => {
                                                        const vals = this.state.boroughs.map(b => this.toInt(((this.state.bulkByBorough[b] || {})[t.key]) || 0));
                                                        return vals.length && vals.every(v => v === vals[0]) ? vals[0] : '';
                                                    })()}
                                                    onChange={(e) => {
                                                        const v = this.toInt(e.target.value);
                                                        this.setState(prev => {
                                                            const nextBulk = { ...prev.bulkByBorough };
                                                            prev.boroughs.forEach(b => {
                                                                const byB = { ...(nextBulk[b] || {}) };
                                                                byB[t.key] = v;
                                                                nextBulk[b] = byB;
                                                            });
                                                            return { bulkByBorough: nextBulk };
                                                        });
                                                    }}
                                                    style={styles.numInput}
                                                />
                                            </div>
                                        ))}
                                        {/* All-times setter inside the controller card */}
                                        <div key="allTimesController" style={styles.allBox}>
                                            <label style={styles.numLabel}>All</label>
                                            <input
                                                type="number"
                                                min="0"
                                                step="1"
                                                value={(() => {
                                                    const vals = [];
                                                    this.state.boroughs.forEach(b => {
                                                        const prev = (this.state.bulkByBorough[b] || {});
                                                        TIMESLOTS.forEach(t => vals.push(this.toInt(prev[t.key] || 0)));
                                                    });
                                                    return vals.length && vals.every(v => v === vals[0]) ? vals[0] : '';
                                                })()}
                                                onChange={(e) => {
                                                    const v = this.toInt(e.target.value);
                                                    this.setState(prev => {
                                                        const nextBulk = { ...prev.bulkByBorough };
                                                        prev.boroughs.forEach(b => {
                                                            const byB = { ...(nextBulk[b] || {}) };
                                                            TIMESLOTS.forEach(t => { byB[t.key] = v; });
                                                            nextBulk[b] = byB;
                                                        });
                                                        return { bulkByBorough: nextBulk };
                                                    });
                                                }}
                                                style={styles.numInput}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 10 }}>
                                {this.state.bulkSaving
                                    ? (<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <div className="loader"></div>
                                        <div style={{ fontSize: 13, color: '#6b7280' }}>Applying month…</div>
                                    </div>)
                                    : <div className="button" onClick={this.confirmBulk}>Save Month</div>
                                }
                            </div>
                        </div>
                    </div>
                )}
                {bulkSavingOverlay}
            </div>
        );
    }
}

/* ---------------- Inline styles to match your visual language ---------------- */
const styles = {
    navBtn: {
        border: '1px solid #d1d5db',
        background: 'white',
        borderRadius: 8,
        padding: '8px 12px',
        cursor: 'pointer',
    },
    monthLabel: {
        fontSize: 22,
        fontWeight: 700,
        color: '#134064',
    },
    weekRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        background: '#f9fafb',
        border: '1px solid #e5e7eb',
        borderRadius: 10,
        overflow: 'hidden',
    },
    weekCell: {
        padding: '8px 10px',
        fontSize: 12,
        fontWeight: 600,
        color: '#6b7280',
        textAlign: 'center',
    },
    grid: {
        marginTop: 8,
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: 8,
    },
    cell: {
        height: 110,
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 10,
        cursor: 'pointer',
        textAlign: 'left',
    },
    cellHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        marginBottom: 6,
    },
    dot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: '#2A6AA9',
    },
    cellBody: {
        marginTop: 2,
        fontSize: 12,
        color: '#374151',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },
    titleText: {
        fontWeight: 600,
        lineHeight: '16px',
        color: '#134064',
    },
    notesText: {
        color: '#6b7280',
        lineHeight: '16px',
    },
    slotBox: {
        padding: 12,
        border: '1px solid #e5e7eb',
        borderRadius: 10,
        background: '#fff'
    },
    slotHeader: {
        fontWeight: 700,
        color: '#137',
        marginBottom: 8
    },
    numField: {
        display: 'grid',
        gridTemplateColumns: '110px 1fr',
        alignItems: 'center',
        gap: 8,
        marginBottom: 8
    },
    numLabel: {
        fontSize: 13,
        color: '#6b7280'
    },
    numInput: {
        width: '100%',
        boxSizing: 'border-box',
        border: '1px solid #d1d5db',
        borderRadius: 8,
        padding: '8px 10px',
        fontSize: 14,
        outline: 'none'
    },
    numFieldCompact: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        alignItems: 'center',
        gap: 6,
        marginBottom: 6
    },
    allBox: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        alignItems: 'center',
        gap: 6,
        marginBottom: 6,
        border: '2px solid #2A6AA9',
        borderRadius: 8,
        padding: '8px 10px'
    },
    applyAllRow: {
        border: '2px dashed #2A6AA9',
        borderRadius: 10,
        padding: 12,
        marginBottom: 16,
        background: '#f8fbff'
    },
    staticValue: {
        width: '100%',
        boxSizing: 'border-box',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        padding: '8px 10px',
        fontSize: 14,
        background: '#f9fafb',
        color: '#374151'
    },
    fab: {
        position: 'fixed',
        right: 20,
        bottom: 20,
        width: 56,
        height: 56,
        borderRadius: '50%',
        border: 'none',
        boxShadow: '0 6px 18px rgba(0,0,0,0.15)',
        fontSize: 28,
        fontWeight: 700,
        lineHeight: '56px',
        textAlign: 'center',
        cursor: 'pointer',
        color: '#fff',
        background: '#2A6AA9'
    }
};

const icon = "menuHours"
export { Calendar, icon }
// Type dropdown methods